import React, { Component } from "react";
import "./index.scss";
import config from "config";
import { Space } from "services/entities/spaces";

interface MapProps {
  url?: string;
  address?: string;
  zoom?: number;
  spaces?: Space[] | null;
}

interface MapLocation {
  lat: string;
  lng: string;
  zoom: number;
}

export default class Map extends Component<MapProps, {}> {
  static parseURLLocation(locationStr: string): MapLocation | null {
    if (!locationStr) {
      return null;
    } else if (locationStr.startsWith("@")) {
      locationStr = locationStr.substr(1);
    }
    const locationParts = locationStr.split(",");
    if (locationParts.length < 3) {
      return null;
    }
    return {
      lat: locationParts[0],
      lng: locationParts[1],
      zoom: parseInt(locationParts[2]),
    };
  }

  static parseMapsURL(url: string): {
    address: string | null;
    location: MapLocation | null;
  } {
    let parsedURL: URL;
    try {
      parsedURL = new URL(url);
    } catch (ex) {
      return { address: null, location: null };
    }
    if (parsedURL.pathname.startsWith("/maps/place/")) {
      const parts = parsedURL.pathname.split("/");
      const address = parts.length > 3 ? parts[3] : null;
      const location = parts.length > 4 ? Map.parseURLLocation(parts[4]) : null;
      return { address: address, location: location };
    } else if (parsedURL.pathname.startsWith("/maps/")) {
      const parts = parsedURL.pathname.split("/");
      const location = parts.length > 3 ? Map.parseURLLocation(parts[3]) : null;
      return { address: null, location: location };
    } else {
      return { address: null, location: null };
    }
  }

  render() {
    const zoom = this.props.zoom || 13;
    let url;
    if (this.props.url) {
      const { address, location } = Map.parseMapsURL(this.props.url);
      if (address) {
        url = `https://www.google.com/maps/embed/v1/place?key=${
          config.google.apiKey
        }&q=${encodeURIComponent(address)}`;
        if (location) {
          url += `&center=${location.lat},${location.lng}&zoom=${location.zoom}`;
        } else {
          url += `&zoom=${zoom}`;
        }
      } else if (location) {
        url = `https://www.google.com/maps/embed/v1/view?key=${config.google.apiKey}&center=${location.lat},${location.lng}&zoom=${location.zoom}`;
      } else {
        // probably won't work - hope for the best
        url = this.props.url;
      }
    } else {
      const address = this.props.address || "";
      url = `https://www.google.com/maps/embed/v1/place?key=${
        config.google.apiKey
      }&zoom=${zoom}&q=${encodeURIComponent(address)}`;
    }
    return <iframe title="map" src={url} className="map" scrolling="no" />;
  }
}
